import { IApplicationState } from '../types/redux';

export function getRegion(state: IApplicationState) {
  return state.filters.region;
}
